<template>

  <v-layout>
      <v-flex xs6>
        <v-layout>
          <img
            :src=thumbnailToShow
            aspect-ratio="2.75"
            class="ma-2 pointer"
            @click="gotoItem"
            />

          <h3 :class="itemClass" @click="gotoItem">
            {{ item.name }}
          </h3>
        </v-layout>
      </v-flex>
      <v-flex xs2 class="price accent--text">
        {{ itemPriceCurrency }}
      </v-flex>
      <v-flex sm2 xs4>
        <v-icon @click="decreaseQuantity">{{$vuetify.icons.decrease}}</v-icon>
        {{ cartItem.numBought }}
        <v-icon @click="increaseQuantity">{{$vuetify.icons.increase}}</v-icon>
        <v-alert
          :value="errorToShow"
          type="error"
          dismissable="true"
          >
          {{ errorToShow }}
        </v-alert>
      </v-flex>

    </v-layout>

</template>

<script>
import utils from '../../utils.ts'

export default {
  name: 'CartItem',
  components: {
  },
  props: ['cartItem'],
  data () {
    return {
      errorToShow: null
    }
  },
  mounted: function () {

  },
  computed: {
    thumbnailToShow: function () {
      const thumbs = this.item.thumbnails
      for (let i = 0; i < thumbs.length; i++) {
        if (thumbs[i]) {
          return thumbs[i].thumbDownloadURL
        }
      }
      return null
    },
    itemPriceCurrency: function () {
      return utils.formatCurrency(this.cartItem.item.price)
    },
    item: function () {
      return this.cartItem.item
    },
    itemClass: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'body-1 mb-1 text-xs-left pointer'
      } else {
        return 'headline mb-1 text-xs-left pointer'
      }
    }
  },
  methods: {
    gotoItem: function () {
      this.$store.commit('shopping/setSelectedItem', this.item)
      this.$router.push({name: 'Item'})
    },
    increaseQuantity: function () {
      this.$store.dispatch('cart/addItemToCart', this.cartItem.item).catch((err) => {
        this.errorToShow = err.message
      })
    },
    decreaseQuantity: function () {
      this.$store.dispatch('cart/removeFromCart', this.cartItem.item).catch((err) => {
        this.errorToShow = err.message
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cartitem {
  margin:10px;

}
.pointer {
  cursor: pointer;
}

.price {
  font-weight: bold;
}
</style>
